<app-modal
  [title]="'admin.customers.edit.options.title' | transloco"
  [subtitle]="'admin.customers.edit.options.subtitle' | transloco"
  [errorMessage]="null"
  [isSubmitting]="false"
  [isDisabled]="false"
  [confirmLabel]="'shared.modal.close' | transloco"
  [submittingLabel]="'admin.customers.edit.options.closing' | transloco"
  (confirm)="close()"
  (cancelled)="close()"
  icon="bi bi-building-gear"
>
  <div class="edit-options">
    <!-- Dados da empresa -->
    <button
      type="button"
      class="edit-option-card bg-color-surface-light border-default"
      (click)="openCustomerDataModal()"
    >
      <span class="edit-option-icon bg-color-surface-lighter text-success-brand">
        <i class="bi bi-building"></i>
      </span>

      <span class="edit-option-content">
        <strong class="font-heading text-primary-brand">
          {{ 'admin.customers.edit.options.companyDataTitle' | transloco }}
        </strong>

        <small class="text-secondary-brand">
          {{ 'admin.customers.edit.options.companyDataSubtitle' | transloco }}
        </small>
      </span>

      <i class="bi bi-chevron-right edit-option-arrow text-secondary-brand"></i>
    </button>

    <!-- Tema -->
    <button
      type="button"
      class="edit-option-card bg-color-surface-light border-default"
      (click)="openCustomerThemeModal()"
    >
      <span class="edit-option-icon bg-color-surface-lighter text-success-brand">
        <i class="bi bi-palette"></i>
      </span>

      <span class="edit-option-content">
        <strong class="font-heading text-primary-brand">
          {{ 'admin.customers.edit.options.themeTitle' | transloco }}
        </strong>

        <small class="text-secondary-brand"> {{ 'admin.customers.edit.options.themeSubtitle' | transloco }} </small>
      </span>

      <i class="bi bi-chevron-right edit-option-arrow text-secondary-brand"></i>
    </button>

    <!-- Logotipo -->
    <button
      type="button"
      class="edit-option-card bg-color-surface-light border-default"
      (click)="openCustomerLogoModal()"
    >
      <span class="edit-option-icon bg-color-surface-lighter text-success-brand">
        <i class="bi bi-image"></i>
      </span>

      <span class="edit-option-content">
        <strong class="font-heading text-primary-brand">
          {{ 'admin.customers.edit.options.logoTitle' | transloco }}
        </strong>

        <small class="text-secondary-brand"> {{ 'admin.customers.edit.options.logoSubtitle' | transloco }} </small>
      </span>

      <i class="bi bi-chevron-right edit-option-arrow text-secondary-brand"></i>
    </button>

    <!-- Modelo de relatório (TG-385: disponível para Admin e Super) -->
    @if (isAdminOrSuper()) {
      <button
        type="button"
        class="edit-option-card bg-color-surface-light border-default"
        (click)="openReportModelModal()"
      >
        <span class="edit-option-icon bg-color-surface-lighter text-success-brand">
          <i class="bi bi-file-earmark-bar-graph"></i>
        </span>

        <span class="edit-option-content">
          <strong class="font-heading text-primary-brand">
            {{ 'admin.customers.edit.options.reportModelTitle' | transloco }}
          </strong>

          <small class="text-secondary-brand">
            {{ 'admin.customers.edit.options.reportModelSubtitle' | transloco }}
          </small>
        </span>

        <i class="bi bi-chevron-right edit-option-arrow text-secondary-brand"></i>
      </button>
    }
  </div>
</app-modal>
